<template lang="html">
	<div class="take-place column activity-container">
		<ag-grid-vue class="table-custom column" :gridReady="onReady" :gridOptions="options" :columnDefs="columnsComputed" :rowData="rows" :enableSorting="true"></ag-grid-vue>
		<div v-if='showGrid && options.pagination' class='table-pagination'>
			<div>Montrer <input v-model="paginationPageSize" type="number" /> éléments par page</div>
			<div>Page <input class='input-page' v-model="currentPage" type="number" /></div>
		</div>
	</div>
</template>

<script>
import { AgGridVue } from 'ag-grid-vue'
export default {
	name: 'ag-table',
	props: ['columns', 'rows', 'customOptions'],
	components: {
		AgGridVue
	},
	data () {
		return {
			defaultOptions: {
				paginationPageSize: 10,
				suppressPaginationPanel: true,
				headerHeight: 50,
				rowHeight: 50,
				pagination: false,
				onRowClicked: this.onRowClicked,
				onCellClicked: this.onCellClicked,
				localeText: {
					noRowsToShow: 'Vous n\'avez encore aucun client'
				},
				onComponentStateChanged: this.afterReady,
				onGridReady: this.afterReady,
				onBodyScroll: this.afterReady,
				onPaginationChanged: this.afterReady
			},
			gridOptions: null,
			showGrid: false
		}
	},
	methods: {
		afterReady () {
			let imgs = document.querySelectorAll('.ag-root-wrapper .ctn-profile-picture img')
			imgs.forEach((img) => {
				let tmp = new Image()
				tmp.addEventListener('load', () => {
					img.classList.add((tmp.width > tmp.height) ? 'landscape' : 'portrait')
					img.classList.remove((tmp.width > tmp.height) ? 'portrait' : 'landscape')
				})
				tmp.src = img.src
			})
		},
		rendering () {
			return {
				dateFormat: (params) => {
					const foo = this.$moment(params.value)
					return `<div class="custom-cell"><span class="bold">${foo.format('DD MMMM YYYY')}</span> <span class="light">${foo.format('dddd')}</span></div>`
				},
				shortDateFormat: (params) => {
					return `<div class="custom-cell no-upper light">${this.$moment(params.value).format('DD/MM/YYYY')}</div>`
				},
				rangeHourFormat: (params) => {
					const start = this.$moment(params.value.start)
					const end = this.$moment(params.value.end)
					return `<div class="custom-cell no-upper no-margin"><span class="light">de </span><span class="bold">${start.format('H')}h </span><span class="light">à </span><span class="bold">${end.format('H')}h</span></div>`
				},
				cabinetFormat: (params) => {
					const {text, color} = params.value
					return `<div class="custom-cell no-margin"><span class="pastille" style="background-color: ${color};"></span><span class="bold">${text}</span></div>`
				},
				typeActivityFormat: (params) => {
					let label = null
					let color = null
					if (params.value === 'appointment') {
						label = 'Rendez-vous'
						color = 'red'
					} else {
						label = 'Visio Call'
						color = 'brown'
					}

					return `<div class="custom-cell no-margin"><span class="pastille ${color}"></span><span class="bold">${label}</span></div>`
				},
				statusAvailableFormat: (params) => {
					let cssClass = ''
					if (params.value) {
						cssClass = 'active'
					}
					return `<div class="custom-cell no-margin">
								<div class="toggle-input ${cssClass}">
									<div class="button"></div>
								</div>
							</div>`
				},
				statusActivityFormat: (params) => {
					let cssClass = null
					let label = null
					if (params.value === 'confirmed') {
						cssClass = 'green'
						label = 'Confirmé'
					} else if (params.value === 'waiting') {
						cssClass = 'orange'
						label = 'En attente'
					} else {
						label = '-'
					}

					return `<div class="custom-cell no-margin"><span class="bold ${cssClass}">${label}</span></div>`
				},
				roundImgFormat: (params) => {
					const img = (params.data.media && params.data.media.file) ? process.env.ASSETS_ROOT + params.data.media.file : process.env.API_ROOT + 'assets/user.png'
					return `<div class="custom-cell ctn-profile-picture"><img src="${img}"></div>`
				},
				typeContactFormat: (params) => {
					const label = (params.value === 'client_subscriber') ? 'Abonné' : 'Prospect'
					return this.rendering().lightFormat({ value: label })
				},
				lightFormat: (params) => {
					return `<div class="custom-cell"><div class="light">${params.value || '-'}</div></div>`
				},
				noUpperFormat: (params) => {
					return `<div class="custom-cell no-upper">${params.value || '-'}</div>`
				},
				currentTaskFormat: (params) => {
					const label = this.taskResolver(params.value)
					return this.rendering().lightFormat({ value: label })
				},
				arrayFormat: (params) => {
					return `<div class="custom-cell"><div class="light">${params.value.length}</div></div>`
				},
				bellCellFormat: (params) => {
					let bell = null
					if (params.value) {
						bell = (params.value === 'warn') ? 'yellow' : 'red'
					} else {
						return `<div></div>`
					}

					return `<div class="custom-cell ${bell}"><span class="icon-alert"></span></div>`
				},
				compactNameFormat: (params) => {
					return params.data.firstname + ' ' + params.data.lastname
				},
				statusMissionFormat: (params) => {
					return this.statusMissionResolver(params.value)
				}
			}
		},
		statusMissionResolver: (value) => {
			let foo = '<div class="custom-cell status-missions row '
			switch (value) {
			case 'En Attente':
				foo += 'orange"><div class="ctn-icon"><span class="icon-volet-notif"></span></div>'
				break
			case 'Signé':
				foo += 'green"><div class="ctn-icon"></div>'
			}
			return foo + '<div class="light">' + value + '</div></div>'
		},
		taskResolver: (value) => {
			let foo = null
			switch (value) {
			case 'active_contract':
				foo = 'Contrat actif'
				break
			case 'report_to_sign':
				foo = 'Compte rendu de mission à signer'
				break
			case 'contract_check':
				foo = 'Contrat à valider'
				break
			case 'heritage_landscape_to_complete':
				foo = 'Paysage Patrimonial à completer'
				break
			case 'project_to_validate':
				foo = 'Projet d\'investissement à valider'
				break
			default:
				foo = '-'
			}
			return foo
		},
		onReady () {
			// to check if gridOptions api has been set
			this.showGrid = true
		},
		onRowClicked (e) {
			this.$emit('rowclick', e)
		},
		onCellClicked (e) {
			this.$emit('cellclick', e)
		}
	},
	computed: {
		paginationPageSize: {
			get () {
				if (this.options && this.options.api) {
					return this.options.api.paginationGetPageSize()
				}
			},
			set (newValue) {
				if (this.options && this.options.api) {
					this.options.api.paginationSetPageSize(newValue)
				}
			}
		},
		currentPage: {
			get () {
				if (this.options && this.options.api) {
					const totalPages = this.options.api.paginationGetTotalPages()
					const pageIndex = this.options.api.paginationGetCurrentPage() + 1
					if (pageIndex <= 0) {
						return 1
					} else if (pageIndex > totalPages) {
						return totalPages
					}
					return pageIndex
				}
			},
			set (newValue) {
				if (this.options && this.options.api) {
					const totalPages = this.options.api.paginationGetTotalPages()
					if (newValue <= totalPages && newValue > 0) {
						this.options.api.paginationGoToPage(newValue - 1)
					}
				}
			}
		},
		columnsComputed () {
			let foo = []
			this.columns.forEach((column) => {
				foo.push({
					headerName: column.name,
					field: column.field,
					cellRenderer: this.rendering()[`${column.cellType}Format`]
				})

				if (column.width) {
					foo[foo.length - 1].width = column.width
				}

				if (column.cellClass) {
					foo[foo.length - 1].cellClass = column.cellClass
				}
			})
			return foo
		},
		options () {
			if (this.customOptions) {
				return ({...this.defaultOptions, ...this.customOptions})
			} else {
				return this.defaultOptions
			}
		}
	}
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// ag-table.vue?9cba8ffe